const styles = (theme) => ({
    root: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    bottom: {
        marginTop: 197,
    },
    lightButton: {
        marginRight: 11,
        opacity: 0.5,
    },
    text: {
        margin: '197px auto 0 auto',
        width: 226,
        color: '#4a4a4a',
    },
    gutterBottom: {
        marginBottom: 15,
    },
});

export default styles;
